module.exports = __webpack_public_path__ + "static/media/defaultlogo.8437254b.png";